import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/lkFcRNm.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-ca14d2b0")

_pushScopeId("data-v-ca14d2b0")
const _hoisted_1 = { style: {"margin-top":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_4 = { style: {"color":"#215ca2"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Attribute Mapping ")
const _hoisted_6 = {
  key: 0,
  style: {"margin":"auto 0"}
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  width: "90"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_result = _resolveComponent("el-result")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_AttributePage = _resolveComponent("AttributePage")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (!_ctx.isMapping)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "products"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary"
              }, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isMapping)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            size: "small",
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMapping = false))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isMapping)
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          gutter: 10,
          type: "flex",
          justify: "center",
          class: "padding-top"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.connectData, (connect) => {
              return (_openBlock(), _createBlock(_Fragment, { key: connect }, [
                _createVNode(_component_el_col, {
                  sm: 8,
                  md: 6,
                  lg: 5.5,
                  xl: 4
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_card, { class: "box-card" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_result, { class: "content-card" }, {
                          title: _withId(() => [
                            _createVNode("strong", _hoisted_4, _toDisplayString(_ctx.truncate(connect.name)), 1)
                          ]),
                          icon: _withId(() => [
                            _createVNode(_component_el_image, {
                              class: "image",
                              src: _ctx.url + connect.platform.image,
                              fit: "contain"
                            }, null, 8, ["src"])
                          ]),
                          extra: _withId(() => [
                            (connect.connectTo)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  size: "small",
                                  type: "primary",
                                  onClick: ($event: any) => (_ctx.handleMapping(connect._id))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_5
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["lg"]),
                (connect.connectFrom && _ctx.connectData.length > 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      _hoisted_7
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isMapping)
      ? (_openBlock(), _createBlock(_component_AttributePage, {
          key: 1,
          idConnect: _ctx.idConnect,
          connectFrom: _ctx.connectFrom,
          modelValue: _ctx.isMapping,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMapping = $event))
        }, null, 8, ["idConnect", "connectFrom", "modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
})